import { ESTIMATE_COLORS } from '@components/ArtBoard/Estimator/constants'
import { Factory } from '@octopus-do/octopus-project-core'

import { getId } from '@/utils/temporaryHelper'

const id = getId()
const color = ESTIMATE_COLORS.at(0)

export const initialLineItem = Factory.estimateLineItem({
  id,
  title: 'Design',
  color,
  rate: 45,
  value: 0,
  linked: true,
})
